import { cn } from '../../lib/cn';

export interface TextProps {
  children: React.ReactNode;
  as?: 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'label';
  variant?: 'display-large' | 'display-medium' | 'headline' | 'title' | 'body' | 'body-medium' | 'label' | 'caption';
  className?: string;
  color?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'error' | 'primary-brand';
}

const variantClasses: Record<NonNullable<TextProps['variant']>, string> = {
  'display-large': 'text-3xl font-bold leading-tight',
  'display-medium': 'text-2xl font-bold leading-tight',
  headline: 'text-xl font-semibold leading-snug',
  title: 'text-lg font-semibold leading-snug',
  body: 'text-base font-normal leading-relaxed',
  'body-medium': 'text-base font-medium leading-relaxed',
  label: 'text-sm font-medium leading-snug',
  caption: 'text-xs font-normal leading-snug',
};

const colorClasses: Record<NonNullable<TextProps['color']>, string> = {
  primary: 'text-slate-900 dark:text-slate-50',
  secondary: 'text-slate-600 dark:text-slate-300',
  tertiary: 'text-slate-400 dark:text-slate-500',
  success: 'text-emerald-600 dark:text-emerald-400',
  warning: 'text-amber-600 dark:text-amber-400',
  error: 'text-red-600 dark:text-red-400',
  'primary-brand': 'text-park-600 dark:text-park-400',
};

export function Text({
  children,
  as: Component = 'p',
  variant = 'body',
  className,
  color = 'primary',
}: TextProps) {
  return (
    <Component
      className={cn(variantClasses[variant], colorClasses[color], className)}
    >
      {children}
    </Component>
  );
}
